module.exports = __webpack_public_path__ + "static/44invgde-48ff50a148ab67009ab4847b1cb80710.gif";